export class ContaBancariaEntidade {
	public SQ_CONTA_BANCARIA: number;
	public CD_FINALIDADE: number;
	public CD_BANCO: string;
	public CD_PESSOA_AGENCIA: number;
	public CD_PESSOA: number;
	public NR_CONTA: string;
	public NR_VARIACAO: string;
	public IR_NATUREZA: string;
	public CD_PESSOA_PAI?: number;
	public NR_CC?: number;
	public DV_CC: string;
	public CD_AGENCIA: string;
}
